import React, { useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import { useState } from "react";
import { API } from "../../Redux/actions/API";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import DOMPurify from "dompurify";

export default function UpgradeID() {
  const { userId } = useSelector((state) => state.Auth);
  const jwt_token = sessionStorage.getItem("jwt_token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [activamount, setActivation] = useState("");
  const [name, setName] = useState("");

  const [utr, setUtr] = useState("");
  const [usd, setUsd] = useState(0);
  const [Token, setToken] = useState(0);
  const [ethereum, setEthereum] = useState(0);
  const [packages, setpackages] = useState([]);
  const [spinnerload, setspinnerload] = useState(false);

  const handleChange = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /\D/g,
      ""
    );
    const limitedValue = sanitizedValue.slice(0, 8);

    setSearch(limitedValue);
    CheckUserId_Api(limitedValue);
  };

  const CheckUserId_Api = async (value) => {
    try {
      let res = await API.post(
        "/CheckUserId",
        {
          loginid: userId,
          uid: value,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("cuser_Api", res.data);
      if (res?.data?.data === "WrongId") {
        setName("Wrong Id");
      } else {
        setSearch(value);
        setName(res?.data?.data);
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };


  const handleAmount = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /\D/g,
      ""
    );
    const limitedValue = sanitizedValue.slice(0, 8);

    setActivation(limitedValue);
    //CheckAmount_Api(limitedValue);
  };

  const CheckAmount_Api = async (camount) => {
    try {
      let res = await API?.post(
        "/ConvertAmount",
        {
          loginid: userId,
          TokenValue: 0,
          EthValue: 0,
          USDValue: camount,
          type: "buy",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //   console.log("amount_Api", res?.data?.data);
      setUsd(res?.data?.data?.usd);
      setToken(res?.data?.data?.Token);
      setEthereum(res?.data?.data?.ethereum);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const packagesList_API = async () => {
    try {
      let responceRight = await API?.post(
        "/GetIncomeReports",
        {
          loginid: userId,
          uid: search,
          status: 0,
          level: 0,
          fdate: "",
          tdate: "",
          type: "Packages",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      responceRight = responceRight?.data?.data[0];

      setpackages(responceRight);
    } catch (error) {
      console.log("Country API ERROR", error);
    }
  };
  const referral_API = async () => {
    try {
      setspinnerload(true);
      let responceRight = await API?.post(
        "/NormalActivation",
        {
          loginid: userId,
          userId: search,
          amount: activamount,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      console.log("My_Team", responceRight);
      if (responceRight.data.data == "Successfully Activated...!!!") {
        toast.success(responceRight.data.data);
        setActivation("");
        setSearch("");
        setName("");
        setTimeout(() => {
          setspinnerload(false);
        }, 10000);
      } else if (responceRight.data.data == "Successfully upgraded...!!!") {
        toast.success(responceRight.data.data);
        setActivation("");
        setSearch("");
        setName("");
        setTimeout(() => {
          setspinnerload(false);
        }, 10000);
      }
      else {
        toast.error(responceRight.data.data);
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    packagesList_API();
  }, []);
  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Upgrade User Id</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="d-flex justify-content-between">
                                  <h1>Upgrade User Id</h1>
                                </div>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>User Id</label>
                                  <input
                                    type="text"
                                    // inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter User Id"
                                    value={search}
                                    onChange={handleChange}
                                  />
                                  {/* {name && <p>{name}</p>} */}
                                  {name && (
                                    <p
                                      className={
                                        name === "Wrong Id"
                                          ? "text-danger"
                                          : "text-success"
                                      }
                                    >
                                      {name}
                                    </p>
                                  )}
                                </div>
                                {/* 
                                <div class="form-group">
                                  <label> Package Amount</label>
                                  <select
                                    className="form-control"
                                    onChange={handleAmount}
                                    value={activamount}
                                  >
                                    <option value="">Select Package</option>
                                    <option value="100">100 USD</option>
                                    <option value="500">500 USD</option>
                                    <option value="1000">1000 USD</option>
                                    <option value="5000">5000 USD</option>
                                    <option value="10000">10000 USD</option>
                                  </select>
                                </div> */}

                                <div className="form-group">
                                  <select
                                    className="form-control bg-transperant shadow-none"
                                    id="Amount"
                                    name="Amount"
                                    value={activamount}
                                    onChange={(e) => {
                                      setActivation(e.target.value);
                                    }}
                                    required>
                                    <option className="text-dark" value="" disabled>
                                      Select Activation Amount
                                    </option>

                                    {packages.map((pack, index) => (
                                      <option
                                        className="text-dark"
                                        key={index}
                                        value={pack.planamount}>
                                        {pack.planname}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                {/* <div class="form-group">
                                  <label>Amount</label>
                                  <input
                                    type="number"
                                    inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Amount"
                                    value={activamount}
                                    onChange={handleAmount}
                                  />
                                </div> */}

                                {/* <div className="form-group">
                                  <label>Txn</label>
                                  <input
                                    type="text"
                                    maxLength={20}
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Remark"
                                    value={utr}
                                    onChange={(e) => setUtr(e.target.value)}
                                  />
                                </div> */}
                                <div class="joinbtn d-flex flex-row-reverse me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => referral_API()}
                                  disabled={spinnerload}>
                                    {spinnerload ? "Processing..." : "Upgrade"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
